import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { resetFilter } from 'redux/actions/newFilter';
import { getListCompany, getAllModules } from '../../redux/actions/company';

import CompanyListPage from './CompanyList.page';

const mapStateToProps = state => ({
  allModules: state.organization.allModules,
  listCompany: state.organization.companyList,
  getLoading: state.organization.getLoading,
  getCompanyListLoading: state.organization.getCompanyListLoading,
  getAllModulesLoading: state.organization.getAllModulesLoading,
  me: state.auth.me,
  viewAll: state.auth.modulesViewAll,
  companyFilter: state.organization.companyFilter,
  filterValue: state.newFilter.filterValue,
  formControlShow: state.newFilter.formControlShow,
});

const mapDispatchToProps = { getListCompany, getAllModules, resetFilter };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CompanyListPage));
